/**
 * @generated SignedSource<<ed0057c30c431dc98a3d53f20f6975f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppBuildState = "DISABLED" | "PENDING_BRAND_SETUP" | "PENDING_KINN_SETUP" | "PRE_PRODUCTION" | "PRODUCTION" | "%future added value";
export type InternScreensAITextGeneratorQuery$variables = {
  id: string;
};
export type InternScreensAITextGeneratorQuery$data = {
  readonly brand: {
    readonly appConfig: {
      readonly appDescription: string;
      readonly appState: AppBuildState;
    };
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"InternTempoConnectionCard_brand">;
  };
};
export type InternScreensAITextGeneratorQuery = {
  response: InternScreensAITextGeneratorQuery$data;
  variables: InternScreensAITextGeneratorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appDescription",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appState",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternScreensAITextGeneratorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternTempoConnectionCard_brand"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternScreensAITextGeneratorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tempoApiToken",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e7a93c09436d9d1332a1c5e963a1d010",
    "id": null,
    "metadata": {},
    "name": "InternScreensAITextGeneratorQuery",
    "operationKind": "query",
    "text": "query InternScreensAITextGeneratorQuery(\n  $id: ID!\n) {\n  brand(id: $id) {\n    id\n    ...InternTempoConnectionCard_brand\n    appConfig {\n      appDescription\n      appState\n      id\n    }\n  }\n}\n\nfragment InternTempoConnectionCard_brand on BrandType {\n  id\n  tempoApiToken\n}\n"
  }
};
})();

(node as any).hash = "e4ca00b2d5f96ff2da1e9449420f36eb";

export default node;
